/* LIV Extensions — Mystery discount popup (v3) */
(function () {
  'use strict';
  if (window.__livMysteryLoaded) return;
  window.__livMysteryLoaded = true;

  var VERSION = 'v3';
  var KEY = 'liv-mystery-discount';
  var COOKIE = 'liv_mystery';
  var SESSION_OPENED = 'liv-mystery-opened';
  var SESSION_APPLIED = 'liv-mystery-applied';
  var DAY = 86400000;
  var CODE_LIFETIME = 30 * DAY;

  /* ---------- Storage: localStorage with a cookie backup ---------- */
  function readCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    if (!m) return null;
    try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; }
  }
  function load() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      if (v) return v;
    } catch (e) {}
    return readCookie() || {};
  }
  function save(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(s)) +
      '; max-age=' + (60 * 60 * 24 * 60) + '; path=/; SameSite=Lax';
  }
  function reset() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    document.cookie = COOKIE + '=; max-age=0; path=/';
    try { sessionStorage.removeItem(SESSION_OPENED); sessionStorage.removeItem(SESSION_APPLIED); } catch (e) {}
  }
  function sessionGet(k) { try { return sessionStorage.getItem(k) === '1'; } catch (e) { return false; } }
  function sessionSet(k) { try { sessionStorage.setItem(k, '1'); } catch (e) {} }
  function base() { return ((window.routes && window.routes.root) || '/').replace(/\/$/, ''); }

  function activeReveal() {
    var r = load().revealed;
    if (!r || !r.code) return null;
    if (r.ts && Date.now() - r.ts > CODE_LIFETIME) return null;
    return r;
  }

  /* ---------- Discount: three layers ---------- */
  function attachDiscount(code) {
    var enc = encodeURIComponent(code);
    /* 1. Shopify's discount link saves the code on this browser */
    return fetch(base() + '/discount/' + enc, { credentials: 'same-origin' })
      .catch(function () {})
      .then(function () {
        /* 2. Attach it to the cart */
        return fetch(base() + '/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code })
        }).catch(function () {});
      })
      .then(function () { sessionSet(SESSION_APPLIED); });
  }

  /* 3. The checkout button carries the code in the checkout link */
  function hookCheckout() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[name="checkout"], input[name="checkout"]');
      if (!btn) return;
      var r = activeReveal();
      if (!r) return;
      e.preventDefault();
      e.stopPropagation();
      btn.disabled = true;
      var go = function () {
        window.location.href = base() + '/checkout?discount=' + encodeURIComponent(r.code);
      };
      var form = btn.form;
      if (!form) { go(); return; }
      /* keep any quantity changes from the cart page */
      fetch(base() + '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).catch(function () {}).then(go);
    }, true);
  }

  function showCartNote() {
    var r = activeReveal();
    var footer = document.querySelector('.cart__footer');
    if (!r || !footer || footer.querySelector('.md-cart-note')) return;
    var note = document.createElement('p');
    note.className = 'md-cart-note';
    note.innerHTML = 'Your <strong></strong> mystery discount (<strong></strong>% off) will be applied at checkout.';
    var bits = note.querySelectorAll('strong');
    bits[0].textContent = r.parish;
    bits[1].textContent = r.pct;
    footer.insertBefore(note, footer.querySelector('.cart__actions'));
  }

  /* ---------- Daily parish offers ---------- */
  function seedFrom(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function rng(a) {
    return function () {
      a |= 0; a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function todaysOffers(parishes, pool) {
    var d = new Date();
    var rand = rng(seedFrom(d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()));
    var list = parishes.map(function (_, i) { return pool[i % pool.length]; });
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(rand() * (i + 1));
      var tmp = list[i]; list[i] = list[j]; list[j] = tmp;
    }
    var map = {};
    parishes.forEach(function (p, i) { map[p] = list[i]; });
    return map;
  }
  function slug(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }

  /* ---------- Popup ---------- */
  function init(root) {
    if (!root || root.dataset.mdReady) return;
    root.dataset.mdReady = 'true';

    var cfg = JSON.parse(root.querySelector('[data-mystery-config]').textContent);
    var pool = cfg.codes.filter(function (c) { return c.code; });
    var dialog = root.querySelector('.md');
    var backdrop = root.querySelector('.md-backdrop');
    var tab = root.querySelector('[data-md-open]');
    var email = root.querySelector('[data-md-email]');
    var submit = root.querySelector('[data-md-submit]');
    var errorEl = root.querySelector('[data-md-error]');
    var signup = root.querySelector('form.md__signup');
    var signupEmail = signup.querySelector('[data-md-signup-email]');
    var signupTags = signup.querySelector('[data-md-tags]');
    var confirmBox = root.querySelector('[data-md-confirm]');
    var shapes = Array.prototype.slice.call(root.querySelectorAll('.md-parish'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-parish-pill]'));
    var parishes = shapes.map(function (g) { return g.getAttribute('data-parish'); });
    var offers = pool.length ? todaysOffers(parishes, pool) : {};
    var params = new URLSearchParams(window.location.search);
    var testing = params.get('mystery') === 'test' || cfg.testMode;
    var chosen = null;
    var lastFocus = null;
    var timer = null;

    root.querySelector('[data-md-empty]').hidden = pool.length > 0;
    root.querySelector('[data-md-version]').hidden = !testing;

    function showStep(name) {
      root.querySelectorAll('.md__step').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; });
    }
    function setParishText(name) {
      root.querySelectorAll('[data-parish-name]').forEach(function (el) { el.textContent = name; });
    }
    function markSelected(name) {
      shapes.forEach(function (g) { g.setAttribute('aria-pressed', String(g.getAttribute('data-parish') === name)); });
      pills.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-parish-pill') === name)); });
    }
    function updateTab() {
      if (!tab) return;
      var r = activeReveal();
      if (r) {
        tab.textContent = 'Your ' + r.pct + '% off';
        tab.hidden = !cfg.reopenTab;
        return;
      }
      tab.textContent = tab.getAttribute('data-default-label');
      var s = load();
      tab.hidden = !(cfg.reopenTab && pool.length && s.snoozeUntil && s.snoozeUntil > Date.now());
    }

    function open(step) {
      clearTimeout(timer);
      lastFocus = document.activeElement;
      showStep(step || 'pick');
      dialog.hidden = false;
      backdrop.hidden = false;
      if (tab) tab.hidden = true;
      document.documentElement.classList.add('md-lock');
      var first = dialog.querySelector('.md__step:not([hidden]) .md-parish, .md__step:not([hidden]) [data-md-email], .md__step:not([hidden]) .md__btn');
      (first || dialog.querySelector('.md__close')).focus();
    }
    function close(snooze) {
      dialog.hidden = true;
      backdrop.hidden = true;
      document.documentElement.classList.remove('md-lock');
      var s = load();
      if (snooze && !s.revealed && !cfg.testMode) {
        s.snoozeUntil = Date.now() + cfg.snoozeDays * DAY;
        save(s);
      }
      updateTab();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function choose(name) {
      chosen = name;
      markSelected(name);
      setParishText(name);
      errorEl.hidden = true;
      showStep('email');
      email.focus();
    }

    function fillReveal(r) {
      setParishText(r.parish);
      root.querySelector('[data-md-pct]').textContent = r.pct;
      root.querySelector('[data-md-code]').textContent = r.code;
    }

    /* Email signup runs in the background after the reveal */
    function sendSignup() {
      return fetch(signup.action, {
        method: 'POST',
        body: new FormData(signup),
        credentials: 'same-origin'
      }).then(function (res) {
        if (res.url.indexOf('/challenge') !== -1 || !res.ok) confirmBox.hidden = false;
      }).catch(function () {
        confirmBox.hidden = false;
      });
    }

    function reveal() {
      if (!chosen || !offers[chosen]) return;
      var value = (email.value || '').trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
      if (!valid) {
        errorEl.textContent = 'Enter a valid email address, like name@example.com.';
        errorEl.hidden = false;
        email.focus();
        return;
      }
      errorEl.hidden = true;
      submit.disabled = true;

      var offer = offers[chosen];
      var result = { parish: chosen, pct: offer.pct, code: offer.code, ts: Date.now() };

      /* Save first, so a reload can never lose the reveal */
      var s = load();
      s.revealed = result;
      delete s.snoozeUntil;
      save(s);

      fillReveal(result);
      confirmBox.hidden = true;
      showStep('reveal');
      dialog.querySelector('[data-step="reveal"] .md__btn').focus();
      showCartNote();
      attachDiscount(result.code);

      signupEmail.value = value;
      signupTags.value = ['newsletter', 'mystery-discount', 'parish-' + slug(chosen), 'mystery-' + offer.pct].join(',');
      sendSignup().then(function () { submit.disabled = false; });
    }

    shapes.forEach(function (g) {
      g.addEventListener('click', function () { choose(g.getAttribute('data-parish')); });
      g.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(g.getAttribute('data-parish')); }
      });
    });
    pills.forEach(function (b) {
      b.addEventListener('click', function () { choose(b.getAttribute('data-parish-pill')); });
    });
    submit.addEventListener('click', reveal);
    email.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); reveal(); }
    });
    signup.addEventListener('submit', function (e) { e.preventDefault(); });

    root.querySelector('[data-md-back]').addEventListener('click', function () { showStep('pick'); });
    root.querySelectorAll('[data-md-dismiss]').forEach(function (el) {
      el.addEventListener('click', function () { close(true); });
    });
    root.querySelector('[data-md-confirm-btn]').addEventListener('click', function () {
      /* Hands the signup to Shopify's spam check page. The discount is already saved. */
      HTMLFormElement.prototype.submit.call(signup);
    });
    if (tab) {
      tab.addEventListener('click', function () {
        var r = activeReveal();
        if (r) { fillReveal(r); open('reveal'); } else { open('pick'); }
      });
    }

    root.querySelector('[data-md-copy]').addEventListener('click', function (e) {
      var btn = e.currentTarget;
      var code = root.querySelector('[data-md-code]').textContent;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () {
          btn.textContent = 'Copied';
          setTimeout(function () { btn.textContent = 'Copy'; }, 1500);
        });
      }
    });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(true); return; }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.slice.call(dialog.querySelectorAll('button, input, [tabindex="0"]'))
        .filter(function (el) { return !el.closest('[hidden]') && el.type !== 'hidden'; });
      if (!items.length) return;
      var firstEl = items[0], lastEl = items[items.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    });

    root._mdOpen = open;
    root._mdClose = function () { close(false); };

    /* ---------- When to open ---------- */
    if (params.get('mystery') === 'test') {
      reset();
      open('pick');
      return;
    }

    var r = activeReveal();
    if (r && !sessionGet(SESSION_APPLIED)) attachDiscount(r.code);
    updateTab();

    if (cfg.designMode) return; /* the editor opens it when the section is selected */
    if (!cfg.enabled || !cfg.showHere || !pool.length) return;
    if (sessionGet(SESSION_OPENED)) return; /* at most once per visit */
    if (!cfg.testMode) {
      if (r) return;
      var st = load();
      if (st.snoozeUntil && st.snoozeUntil > Date.now()) return;
    }
    timer = setTimeout(function () {
      sessionSet(SESSION_OPENED);
      open('pick');
    }, cfg.delay * 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-mystery]').forEach(init);
    hookCheckout();
    showCartNote();
    if (window.console) console.info('LIV mystery popup ' + VERSION);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-mystery]'));
  });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector('[data-mystery]');
    if (!root) return;
    init(root);
    if (root._mdOpen) root._mdOpen('pick');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var root = e.target.querySelector('[data-mystery]');
    if (root && root._mdClose) root._mdClose();
  });
})();